import RoundedRow from './RoundedRow';

type TypeRowProps = {
  type: 'event' | 'spin';
};

const TypeRow = ({ type }: TypeRowProps) => {
  return (
    <RoundedRow>
      <div className="tw-px-[10px] tw-py-[10px] tw-text-center tw-text-[8px] tw-font-bold tw-text-white lg:tw-text-[18px]">
        <span className={type === 'spin' ? 'tw-text-[#00EB8A]' : 'tw-text-white'}>Spin</span>
        <span> | </span>
        <span className={type === 'event' ? 'tw-text-[#00EB8A]' : 'tw-text-white'}>Event</span>
      </div>
    </RoundedRow>
  );
};

export default TypeRow;
